var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2E3B4E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.65112,5.1534007e-15 L42.6694771,5.1534007e-15 C19.1066886,5.1534007e-15 0,19.1008864 0,42.6694771 L0,212.65112 C0,236.219711 19.1066886,255.320597 42.6694771,255.320597 L212.65112,255.320597 C236.219711,255.320597 255.320597,236.219711 255.320597,212.65112 L255.320597,42.6694771 C255.326399,19.1008864 236.225513,0 212.65112,0 L212.65112,5.1534007e-15 Z M208.90289,195.447557 C208.90289,202.885995 202.87439,208.908692 195.441755,208.908692 L59.907853,208.908692 C52.4694155,208.908692 46.4409158,202.885995 46.4409158,195.447557 L46.4409158,59.907853 C46.4409158,52.4694155 52.4694155,46.4409158 59.907853,46.4409158 L195.441755,46.4409158 C202.87439,46.4409158 208.90289,52.4694155 208.90289,59.907853 L208.90289,195.447557 L208.90289,195.447557 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.569764,162.479381 C96.2993353,162.479381 92.8412161,158.998053 92.8412161,154.710217 L92.8412161,100.61038 C92.8412161,96.3225441 96.2993353,92.8412161 100.569764,92.8412161 L154.750833,92.8412161 C159.032866,92.8412161 162.479381,96.3225441 162.479381,100.61038 L162.479381,154.710217 C162.479381,158.998053 159.032866,162.479381 154.750833,162.479381 L100.569764,162.479381 L100.569764,162.479381 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/SquareLogo.506e4c382ea1951b64f888725010adba.svg";
export { ForwardRef as ReactComponent };